import React, { Component } from 'react';

export default class DriverManagement extends Component {
    render() {
        return <h1>DriverManagement</h1>;
    }
}



// WEBPACK FOOTER //
// ./src/modules/Transport/components/DriverManagement/DriverManagement.js